module.exports = __webpack_public_path__ + "static/media/alexa_logo.57ef5472.svg";